<template>
  <div class="d-flex">
    <span
      v-tooltip="
        subscribed
          ? 'Contacts that were added to a group after it was subscribed to this campaign and thus are not subscribed.'
          : null
      "
    >
      {{ subscribed ? audience.missing_direct_subscribers : '' }}
    </span>
    <button
      v-if="subscribed && audience.missing_direct_subscribers"
      v-tooltip="'Subscribe missing contacts'"
      class="btn btn-primary ml-3"
      :disabled="loading"
      @click="onSubscribeButtonClick"
    >
      <i class="fas fa-fw" :class="loading ? 'fa-spinner fa-spin' : 'fa-plus'"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'missing-direct-subscribers-cell',
  props: {
    audience: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    subscribed() {
      return this.audience.status === 'subscribed';
    },
  },
  methods: {
    onSubscribeButtonClick() {
      if (!this.loading) {
        this.$emit('subscribe');
      }
    },
  },
};
</script>
